import { Parcella } from './parcella';

export class ParcellaGiudiziale extends Parcella {

}
